export default __webpack_public_path__ + "static/media/galery_photo2@2x.44e75f0b.png";